import React from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { CODE_EXPORT } from 'drapcode-constant';

const ExportNav = ({ activeTab, version, projectId }) => {
  return (
    <nav className="navbar navbar-expand-lg bg-primary">
      <div className="container">
        <div className="navbar-translate">
          <div className="navbar-brand">
            <i className={`wb ${drapcodeIcon(activeTab)}`} size={'md'}></i>&nbsp;
          </div>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className={`nav-item ${activeTab === 'codeExport' && 'active'}`}>
              <Link
                to={`/deployment-setting/${version}/v/${projectId}/code-export`}
                className="nav-link"
              >
                <i className={`wb ${drapcodeIcon('codeExport')}`}></i>
                &nbsp; Code Export
              </Link>
            </li>
            <li className={`nav-item ${activeTab === 'deployment' && 'active'}`}>
              <Link to={`/deployment-setting/${version}/v/${projectId}/`} className="nav-link">
                <i className={`wb ${drapcodeIcon('deployment')}`}></i>
                &nbsp; Deployment Setting
              </Link>
            </li>
            <li className={`nav-item ${activeTab === 'DATABASE' && 'active'}`}>
              <Link
                to={`/deployment-setting/${version}/v/${projectId}/dump-export`}
                className="nav-link"
              >
                <i className={`wb ${drapcodeIcon('DATABASE')}`}></i>
                &nbsp;Dump Export
              </Link>
            </li>
            <li className={`nav-item ${activeTab === 'Github' && 'active'}`}>
              <Link
                to={`/deployment-setting/${version}/v/${projectId}/github-export`}
                className="nav-link"
              >
                <i className="wb webconnect-github"></i>
                &nbsp;Github Setting
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default ExportNav;
